import * as tags from '../ticket-tag'

// TODO: move api to here later.
export default tags
